import React, { useEffect } from "react";

// 參考：https://tricohobby.net/trico/2443/
const CustomVCode = ({onValueChange}) => {
  const baseColor = ["#0000ff", "#CE0000", "#7E3D76", "#46A3FF"]; //底色
  const sColor = ["#B22222", "#F9F900", "#82D900", "#FFAF60"]; //干擾點顏色
  const fColor = ["#FFA07A", "#00BB00", "#EAC100", "#F75000"]; //文字顏色
  let validate = "";
  let indexColor = ""; //顏色組序號
  //   const cxt = createRef()

  // Method
  /*生成隨機顏色組合序號*/
  const randColor = () => {
    indexColor = "";
    indexColor = Math.floor(Math.random() * baseColor.length); //亂數取得 0~顏色陣列長度
    return indexColor;
  };

  /*生成6位隨機數*/
  const rand = () => {
    validate = "";
    // 大小寫英文 數字 排除 I l o O 0  ,並重複數字 增加出現機率
    const str =
      "123456789abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ123456789";
    const arr = str.split("");
    let ranNum;
    for (let i = 0; i < 6; i++) {
      ranNum = Math.floor(Math.random() * 66); //隨機數在[0,65]之間
      validate += arr[ranNum];
    }
    onValueChange(validate);
    return validate;
  };

  /*干擾線的隨機x坐標值*/
  const lineX = () => {
    const ranLineX = Math.floor(Math.random() * 130);
    return ranLineX;
  };

  /*干擾線的隨機y坐標值*/
  const lineY = () => {
    const ranLineY = Math.floor(Math.random() * 40);
    return ranLineY;
  };

  /*更換內容*/
  const clickChange = () => {
    // console.log("[Test] cxt :",cxt);
    const canvas = document.getElementById("mycanvas");
    let cxt = canvas.getContext("2d");

    if (!cxt) {
      return;
    }
    const i = randColor(); //執行randColor()取得顏色組序號
    cxt.beginPath();
    cxt.fillStyle = baseColor[i]; //底色
    cxt.fillRect(0, 0, 130, 40); //(x,y,width,height)

    /*生成干擾點 40*/
    for (let j = 0; j < 40; j++) {
      //產生一個新路徑，產生後再使用繪圖指令來設定路徑
      //若省略beginPath，則每點擊一次驗證碼會累積干擾線的條數
      cxt.beginPath();
      cxt.fillStyle = sColor[i]; //顏色
      const arcSize = (Math.floor(Math.random() * (50 - 5 + 1)) + 5) / 10; //亂數 取得介於0.5~5之間的值
      cxt.arc(lineX(), lineY(), arcSize, 0, 2 * Math.PI); //arc()產生一個圓形  context.arc(x,y,r,sAngle,eAngle,counterclockwise);
      cxt.fill();
    }
    cxt.fillStyle = fColor[i]; //隨機文字顏色
    cxt.font = "bold 25px Verdana";
    cxt.fillText(rand(), 10, 30); //把rand()生成的隨機數文本填充到canvas中
  };

  /*點擊刷新*/
  const onClickRefresh = () => {
    clickChange();
  }

  // useEffect
  useEffect(() => {
    clickChange();
  }, []);

  return (
    <div className="vcodewrap" onClick={() => onClickRefresh()}>
      <canvas id="mycanvas" width="130" height="40"></canvas>
    </div>
  );
};

export default CustomVCode;
